<!--
 * @Description: 对比地图
 * @Date: 2022-11-02 16:17:47
-->
<template>
  <div class="main">
    <div class="left">
      <div class="item__txt">
        <h1 v-if="detail.customerName">目标名称：</h1>
        <BaseToolTip
          popper-class="main__tooltip"
          effect="dark"
          :content="detail.customerName"
          placement="top-start"
        >
          <p v-if="detail.customerName" class="ellipsis">
            {{ detail.customerName }}
          </p>
        </BaseToolTip>
      </div>
      <div class="item__txt">
        <h1 v-if="detail.customerName">目标地址：</h1>
        <BaseToolTip
          popper-class="main__tooltip"
          effect="dark"
          :content="detail.visitAddress"
          placement="top-start"
        >
          <p v-if="detail.customerName" class="ellipsis">
            {{ detail.visitAddress }}
          </p>
        </BaseToolTip>
      </div>
      <div class="item__txt">
        <h1 v-if="detail.customerName">省市区：</h1>
        <BaseToolTip
          popper-class="main__tooltip"
          effect="dark"
          :content="detail.ssq"
          placement="top-start"
        >
          <p v-if="detail.customerName" class="ellipsis">
            {{ detail.ssq }}
          </p>
        </BaseToolTip>
      </div>
      <div class="item__img">
        <h1>任务提交原图：</h1>
        <div>
          <BaseImage
            :previewTeleported="true"
            fit="contain"
            :src="detail.addressWatermarkPicUrl"
            :preview-src-list="[detail.addressWatermarkPicUrl]"
          ></BaseImage>
        </div>
      </div>
    </div>
    <div class="stick"></div>
    <div class="right">
      <div style="margin-bottom: 15px">
        <BaseAutocomplete
          style="width: 80%"
          v-model="address"
          :fetch-suggestions="querySearch"
          ref="addrselect"
          @select="handleSelect"
        ></BaseAutocomplete>
        <BaseButton @click="initMap" type="primary">搜索</BaseButton>
      </div>
      <h1>地图信息：</h1>
      <div class="map__container" id="diff-map-container"></div>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { onMounted, ref, onUnmounted } from 'vue';
import {
  BaseToolTip,
  BaseButton,
  BaseAutocomplete,
  BaseImage
} from 'xrk-components';
import { locationMapComparison } from '../data-source/apis';
import { ProjectType } from '../types';
import jsonp from 'jsonp';
import { QQ_MAP_KEY } from '@/config';
const props = withDefaults(
  defineProps<{
    taskRecordId: number;
    projectId: number;
    projectType: ProjectType;
    dataState: number;
    done?: Function;
  }>(),
  {}
);
const qq = Reflect.get(window, 'qq');
const address = ref('');
const detail = ref({
  customerName: '',
  visitAddress: '',
  ssq: '',
  addressWatermarkPicUrl: '',
  visitLongitude: '',
  visitLatitude: ''
});

const map = ref(null);
const marker = ref(null);

const mapSuggestion = keyword => {
  return new Promise(resolve => {
    try {
      jsonp(
        `//apis.map.qq.com/ws/place/v1/suggestion?keyword=${keyword}&output=jsonp&page_size=20&page_index=1&key=${QQ_MAP_KEY}`,
        null,
        (err, data) => {
          if (err) {
            console.log(err);
          } else {
            resolve(data.data);
          }
        }
      );
    } catch (error) {
      console.log(error);
      resolve([]);
    }
  });
};

const handleSelect = item => {
  //经度
  detail.value.visitLongitude = item.address.lng;
  //纬度
  detail.value.visitLatitude = item.address.lat;
};
const querySearch = (queryString, cb) => {
  if (!address.value) {
    cb([]);
    return;
  }
  mapSuggestion(address.value).then((res: any[]) => {
    let resList = res.map(item => {
      return {
        value: item.title + `(${item.address})`,
        address: item.location
      };
    });
    cb(resList);
  });
};
const initMap = () => {
  const lat = detail.value.visitLatitude;
  const lng = detail.value.visitLongitude;
  const options = {
    zoom: 17,
    pitchable: false,
    rotatable: false,
    disableDefaultUI: true,
    mapTypeId: qq.maps.MapTypeId.ROADMAP
  };
  options['center'] = new qq.maps.LatLng(lat, lng);
  map.value = new qq.maps.Map(
    document.getElementById('diff-map-container'),
    options
  );
  marker.value = new qq.maps.Marker({
    animation: null,
    position: new qq.maps.LatLng(lat, lng),
    map: map.value
  });
};
const handleEsc = event => {
  if (event.key === 'Escape') {
    props.done();
  }
};
onMounted(async () => {
  const { data } = await locationMapComparison({
    sceneType: props.projectType,
    projectId: props.projectId,
    taskRecordId: props.taskRecordId,
    dataState: props.dataState
  });
  Object.assign(detail.value, data);
  initMap();
  window.addEventListener('keydown', handleEsc);
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleEsc);
});
</script>
<style lang="scss">
.main__tooltip {
  max-width: 50vw !important;
}
</style>
<style lang="scss" scoped>
.main {
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  background: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 25px 0;
  width: 95%;
  font-size: 16px;
  height: 65vh;
  .ellipsis {
    width: 100%;
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏溢出的内容 */
    text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
  }
  .left {
    width: 50%;
    height: 100%;
    padding-left: 10px;
    .item__txt {
      display: flex;
      margin-top: 10px;
      h1 {
        min-width: 140px;
      }
      p {
        max-width: 566px;
        margin-right: 20px;
      }
    }
    .item__img {
      margin-top: 15px;
      div {
        background: #f2f2f2;
        width: 98%;
        height: 35vh;
        text-align: center;
      }
      h1 {
        margin-bottom: 15px;
        width: 140px;
      }
    }
  }
  .stick {
    width: 1px;
    height: 90%;
    background: #000;
  }
  .right {
    padding-left: 20px;
    width: 50%;
    height: 100%;
    // padding-top: 80px;
    .map__container {
      margin-top: 10px;
      width: 98%;
      height: 50vh;
    }
  }
}
</style>
